import { render, staticRenderFns } from "./ProfilePhoto.vue?vue&type=template&id=61aed4ae&scoped=true&"
import script from "./ProfilePhoto.vue?vue&type=script&lang=js&"
export * from "./ProfilePhoto.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePhoto.vue?vue&type=style&index=0&id=61aed4ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61aed4ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/pawan/Vizmo/Max/dashboard-old/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
installComponents(component, {VAvatar,VBtn,VIcon,VProgressCircular,VSnackbar})
